export default "__VITE_ASSET__2c1b420a__"